import { Grid, Autocomplete, TextField } from '@mui/material';
import type { PokemonOption } from '../../types/pokemon';
import { normalizeForSearch } from '../../utils/search';

interface PokemonSelectInputProps {
  pokemonOptions: PokemonOption[];
  handleAddAttackPokemon: (event: any, newValue: any) => void;
  label: string;
  placeholder: string;
}

function PokemonSelectInput({ pokemonOptions, handleAddAttackPokemon, label, placeholder }: PokemonSelectInputProps) {
  // 攻守モード共通のポケモン検索 UI をまとめておく
  return (
    <Grid size={{ xs: 12, md: 6 }}>
      <Autocomplete
        options={pokemonOptions}
        getOptionLabel={(option) => option.label}
        onChange={handleAddAttackPokemon}
        value={null}
        filterOptions={(options, { inputValue }) => {
          if (!inputValue) return options;

          const normalizedInput = normalizeForSearch(inputValue);
          return options.filter((option) => normalizeForSearch(option.label).includes(normalizedInput));
        }}
        renderInput={(params) => (
          <TextField {...params} label={label} placeholder={placeholder} variant="outlined" fullWidth />
        )}
      />
    </Grid>
  );
}

export default PokemonSelectInput;
